import { ChangeEvent, useState } from "react";
import cn from "classnames";
import { useAppDispatch } from "../../../store/hooks";
import { addServiceData } from "../../../store/ses/sesRobotSlice";
import useTranslate from "../../../hooks/useTranslate";
import { ROBOT_SERVICE_TYPE_EXTENDED_LIST, ServiceTypeRobotExtended } from "../../../constants/robotConfigLists";
import { ServiceTypeRobot } from "../../../types/cloudTypes";
import { IFormAddingServiceDataProps } from "./FormAddingServiceData.props";
import styles from "./FormAddingServiceData.module.scss";
import { CustomMenuItem, CustomTextField } from "@/ui";

const FormAddingServiceData = ({ serviceDataName, changeFlgHandler }: IFormAddingServiceDataProps): JSX.Element => {
	const [selectType, _setSelectType] = useState<ServiceTypeRobotExtended>("chooseType"); // тип

	const dispatch = useAppDispatch();

	const translate = useTranslate(); // hook для перевода текста

	// обработчик добавления сервисных данных
	const addServiceDataHandler = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
		const value = e.target.value as ServiceTypeRobot;
		dispatch(addServiceData({ serviceDataName, type: value }));
		changeFlgHandler("servicedata"); // ставим флаг о несохраненных данных
	};

	return (
		<div
			className={cn(styles.container, {
				[styles.containerOpacity]: selectType === "chooseType",
			})}
		>
			{/* тип */}
			<CustomTextField select fullWidth label={translate("select_type")} value={selectType} onChange={addServiceDataHandler}>
				{ROBOT_SERVICE_TYPE_EXTENDED_LIST.map(({ type, translation }) => (
					<CustomMenuItem key={type} value={type} disabled={type === "chooseType"}>
						{translate(translation)}
					</CustomMenuItem>
				))}
			</CustomTextField>
		</div>
	);
};

export default FormAddingServiceData;
